<template>
  <app-page labelledby="warehouse-settings-title">
    <page-header title-id="warehouse-settings-title" title="Настройки склада" description="Справочники, операции и параметры складского учета." />
    <q-list class="warehouse-settings-menu" data-testid="warehouse-settings-menu" aria-label="Разделы настроек склада">
      <q-item v-for="item in items" :key="item.route" clickable :to="{ name: item.route }" :data-testid="item.testId || undefined">
        <q-item-section avatar><q-icon :name="item.icon" color="primary" /></q-item-section>
        <q-item-section><q-item-label>{{ item.title }}</q-item-label><q-item-label caption>{{ item.description }}</q-item-label></q-item-section>
        <q-item-section side><q-icon name="chevron_right" /></q-item-section>
      </q-item>
    </q-list>
  </app-page>
</template>

<script>
import { AppPage, PageHeader } from '../../components/ui'
export default {
  name: 'WarehouseSettingsHub', components: { AppPage, PageHeader },
  data: () => ({ items: [
    { title: 'Склады', description: 'Места хранения и их статус', icon: 'warehouse', route: 'store_warehouses' },
    { title: 'Ввод остатков', description: 'Начальные количества и стоимость', icon: 'playlist_add', route: 'store_operation_opening' },
    { title: 'Перемещение', description: 'Движение между складами', icon: 'swap_horiz', route: 'store_operation_transfer' },
    { title: 'Инвентаризация', description: 'Фактические остатки и расхождения', icon: 'fact_check', route: 'store_operation_adjustment' },
    { title: 'Списание', description: 'Выбытие запасов и счет затрат', icon: 'delete_sweep', route: 'store_operation_write_off' },
    { title: 'Параметры', description: 'Значения по умолчанию и отображение', icon: 'tune', route: 'store_settings_parameters', testId: 'warehouse-settings-parameters-link' }
  ] })
}
</script>

<style scoped>
.warehouse-settings-menu { max-width: 31.25rem; }
.warehouse-settings-menu :deep(.q-item) { min-height: 4.5rem; border-bottom: 1px solid var(--sid-color-line); }
</style>
